// Recovered compiled webpack factory 5829. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "isNextRouterError", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(37099),
    a = r(86437);
  function o(e) {
    return (0, a.isRedirectError)(e) || (0, n.isHTTPAccessFallbackError)(e);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
